import type { ClassAnalyticsProperties } from '@engage/classes';
import { toClassAnalytics } from '@engage/classes';

export const toTrackClassEvent = (event: string) => (
  classInfo: ClassAnalyticsProperties,
  source: BookmarkSource,
) => ({
  event,
  source,
  ...toClassAnalytics(classInfo),
});

export enum BookmarkSource {
  OnDemand = 'On-Demand',
  ClassDetails = 'Class Details',
  StudioPostClassSummary = 'Studio Post-Class Summary',
  Collections = 'Collections',
  ClassSearch = 'Class Search',
  ArtistSearch = 'Artist Search',
  Homescreen = 'Homescreen',
}
